import React from 'react'

// Color palette is deliberately low-saturation to fit the rest of the UI.
// Each entry_type gets a distinct hue so users can scan a list and tell
// tools from projects at a glance.
const STYLES = {
  tool:       { classes: 'bg-blue-100 text-blue-800 border-blue-200',         label: 'Tool' },
  project:    { classes: 'bg-purple-100 text-purple-800 border-purple-200',   label: 'Project' },
  process:    { classes: 'bg-emerald-100 text-emerald-800 border-emerald-200',label: 'Process' },
  capability: { classes: 'bg-orange-100 text-orange-800 border-orange-200',   label: 'Capability' },
  insight:    { classes: 'bg-amber-100 text-amber-800 border-amber-200',      label: 'Insight' },
  goal:       { classes: 'bg-rose-100 text-rose-800 border-rose-200',         label: 'Goal' },
  impact:     { classes: 'bg-teal-100 text-teal-800 border-teal-200',         label: 'Impact' },
  resource:   { classes: 'bg-slate-100 text-slate-700 border-slate-200',      label: 'Resource' },
}

export default function EntryTypeBadge({ entryType, className = '' }) {
  const style = STYLES[entryType] || STYLES.resource
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${style.classes} ${className}`}
    >
      {style.label}
    </span>
  )
}

export const ENTRY_TYPE_LABELS = Object.fromEntries(
  Object.entries(STYLES).map(([key, { label }]) => [ key, label ])
)
